import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const EditEmail = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [newEmail, setNewEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve token from local storage
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    // Fetch current user details
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
        setNewEmail(user.email);
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleEmailChange = (e) => {
    setNewEmail(e.target.value);
  };


  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${config.baseURL}/update-email`, 
        { email: newEmail }, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccessMessage(response.data.message);
      setErrorMessage('');
      setUserData({ ...userData, email: newEmail });
    } catch (error) {
      setErrorMessage(error.response.data.message || 'Error updating email');
      setSuccessMessage('');
      console.error('Error updating email', error);
    }
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                 </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSubmit}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">                    
                    <h1>Change Email</h1>
                  </div>
                </div>
                <div className="editable_fields_user edit_username_field with_top_fixed_heading">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-4 position_relative">
                        <input
                          type="email"
                          value={newEmail}
                          onChange={handleEmailChange}
                          className="form-control"
                          id="email"
                          required
                          placeholder="Enter new email"
                        />
                        <label htmlFor="current-email" className="placeholder-label active_label">
                          Current email
                        </label>
                        <div className="word_count patreo_username">
                          Email {userData.email} is verified
                        </div>
                      </div>
                    </div>
                  </div>
                  {errorMessage && (
                    <div className="row">
                      <div className="col-md-12 mb-4 text-danger">
                        {errorMessage}
                      </div>
                    </div>
                  )}
                  {successMessage && (
                    <div className="row">
                      <div className="col-md-12 mb-4 text-success">
                        {successMessage}
                      </div>
                    </div>
                  )}
                  <div className="divider_line" />
                  <div className="row">
                    <div className="col-md-12 text-right">
                      <button type="submit" className="g-btn m-rounded border-none m-border m-block">
                        Update email address
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmail;
